// Course data: metadata for all 12 modules + full content for the FREE module only.
// Paid module content lives on the backend and is loaded on demand after the server
// confirms the user has paid access.

export const FREE_MODULE_IDS = [1];

export const courseModules = [
  {
    id: 1,
    slug: "introduction",
    title: "Introduction & How to Use",
    shortTitle: "Introduction",
    icon: "BookOpen",
    description: "Welcome to your digital safety journey",
    estimatedTime: "5 min",
    isFree: true,
  },
  { id: 2, slug: "strong-passwords", title: "Strong Passwords Made Simple", shortTitle: "Passwords", icon: "Lock", description: "Create passwords that protect you", estimatedTime: "10 min", isFree: false },
  { id: 3, slug: "device-passcodes", title: "Device Passcodes & Lock Screens", shortTitle: "Passcodes", icon: "Smartphone", description: "Keep your phone and tablet safe", estimatedTime: "8 min", isFree: false },
  { id: 4, slug: "two-step-verification", title: "Two-Step Verification (2FA)", shortTitle: "2FA", icon: "ShieldCheck", description: "Add an extra layer of security", estimatedTime: "12 min", isFree: false },
  { id: 5, slug: "backups", title: "Backups: Your Safety Net", shortTitle: "Backups", icon: "CloudUpload", description: "Never lose your important files", estimatedTime: "10 min", isFree: false },
  { id: 6, slug: "emergency-steps", title: "When Things Go Wrong", shortTitle: "Emergency Steps", icon: "AlertTriangle", description: "Quick steps for when something feels wrong", estimatedTime: "10 min", isFree: false },
  { id: 7, slug: "spotting-scams", title: "Spotting Scams", shortTitle: "Scams", icon: "Eye", description: "Recognise and avoid common scams", estimatedTime: "15 min", isFree: false },
  { id: 8, slug: "wifi-safety", title: "Wi-Fi Safety", shortTitle: "Wi-Fi Safety", icon: "Wifi", description: "Stay safe on home and public Wi-Fi", estimatedTime: "10 min", isFree: false },
  { id: 9, slug: "updates", title: "Keeping Software Up to Date", shortTitle: "Updates", icon: "RefreshCw", description: "Why updates matter and how to manage them", estimatedTime: "8 min", isFree: false },
  { id: 10, slug: "privacy-settings", title: "Privacy Settings", shortTitle: "Privacy", icon: "User", description: "Control what you share online", estimatedTime: "12 min", isFree: false },
  { id: 11, slug: "safe-browsing", title: "Safe Browsing", shortTitle: "Safe Browsing", icon: "Globe", description: "Browse the web without getting caught out", estimatedTime: "10 min", isFree: false },
  { id: 12, slug: "family-community", title: "Family & Community Safety", shortTitle: "Family Safety", icon: "Users", description: "Protect your loved ones together", estimatedTime: "10 min", isFree: false },
];
export const australianResources = [
  {
    name: "Scamwatch",
    url: "https://www.scamwatch.gov.au",
    description: "Report scams and learn about the latest scam tactics"
  },
  {
    name: "eSafety Commissioner",
    url: "https://www.esafety.gov.au",
    description: "Australia's online safety regulator - help with cyberbullying, image abuse, and more"
  },
  {
    name: "IDCARE",
    url: "https://www.idcare.org",
    description: "Free help if your identity has been compromised"
  },
  {
    name: "Australian Cyber Security Centre",
    url: "https://www.cyber.gov.au",
    description: "Report cyber incidents and get security advice"
  },
  {
    name: "ReportCyber",
    url: "https://www.cyber.gov.au/report",
    description: "Report cybercrime to the Australian Government"
  }
];

export const glossary = [
  {
    term: "Phishing",
    definition: "A scam where criminals pretend to be trusted organisations to trick you into revealing personal information, passwords, or financial details."
  },
  {
    term: "2FA (Two-Factor Authentication)",
    definition: "An extra security step where you need both your password AND another form of verification (like a code sent to your phone) to log in."
  },
  {
    term: "Passphrase",
    definition: "A password made up of multiple words strung together, making it longer and more secure than a traditional password."
  },
  {
    term: "HTTPS",
    definition: "A secure version of HTTP (how websites communicate). The 'S' means the connection is encrypted and safer for entering personal information."
  },
  {
    term: "Malware",
    definition: "Malicious software designed to damage, disrupt, or gain unauthorised access to your device or information."
  },
  {
    term: "Ransomware",
    definition: "A type of malware that locks your files or device and demands payment to unlock them."
  }
];
